// extracted by mini-css-extract-plugin
export var container = "_mb-0";
export var dotAnimation = "_mb-2";
export var dotsLoading = "_mb-1";